// src/stores/Factors.js
import { ref } from "vue";
import { defineStore } from "pinia";
import apiClient from "@/axios";
import { useToast } from "vue-toastification";
const toast = useToast();

export const usePermissionAccessStore = defineStore("permissionAccess", () => {
    const permissionAccessEntity = ref([]);
    const loading = ref(false);

    async function fetchUserPermissionAsync(userId) {
        try {
            const response = await apiClient.get(`/PermissionAccess/GetUserPermissionAsync?userId=${userId}`);
            const raw = response && response.data;
            const normalized = Array.isArray(raw) ? raw : (raw && Array.isArray(raw.data) ? raw.data : []);
            permissionAccessEntity.value = normalized;
            return normalized;
        } catch (error) {
            console.error("Error fetching Permission:", {
                message: error?.message,
                status: error?.response?.status,
                url: error?.config?.url,
                response: error?.response?.data,
            });
            permissionAccessEntity.value = [];
            return [];
        }
    }

    async function fetchPermissionAccess() {
        try {
            const response = await apiClient.get(`/PermissionAccess/GetCurrenctUserPermissionAsync`);
            const raw = response && response.data;
            const normalized = Array.isArray(raw) ? raw : (raw && Array.isArray(raw.data) ? raw.data : []);
            permissionAccessEntity.value = normalized;
            return normalized;
        } catch (error) {
            console.error("Error fetching Permission:", {
                message: error?.message,
                status: error?.response?.status,
                url: error?.config?.url,
                response: error?.response?.data,
                hasToken: Boolean(localStorage.getItem('token')),
            });
            permissionAccessEntity.value = [];
            return [];
        }
    }
    async function saveUserPermissionAccess(permissionData) {
        loading.value = true;
        try {
            const response = await apiClient.post('/PermissionAccess/SaveUserPermissionAccess', permissionData);

            if (response.status === 200) {
                toast.success("دسترسی ها با موفقیت ثبت شد");
            } else {
                toast.error("خطا در ثبت دسترسی ها");
                console.error(response.data);
            }
        } catch (error) {
            console.error("Error adding doctor:", error);
            toast.error("خطا در ثبت دسترسی ها");
        } finally {
            loading.value = false;
        }
    }

    // Batch save: accepts an array of permission change payloads
    async function saveUserPermissionAccessBatch(permissionDataArray) {
        loading.value = true;
        try {
            // POST batch payload to the batch endpoint
            const response = await apiClient.post('/PermissionAccess/SaveUserPermissionAccessBatch', permissionDataArray);

            if (response.status === 200) {
                toast.success("دسترسی‌ها با موفقیت ثبت شدند");
            } else {
                toast.error("خطا در ثبت دسته‌ای دسترسی‌ها");
                console.error(response.data);
            }
            return response.data;
        } catch (error) {
            console.error("Error saving permission batch:", error);
            toast.error("خطا در ثبت دسته‌ای دسترسی‌ها");
            throw error;
        } finally {
            loading.value = false;
        }
    }

    return {
        permissionAccessEntity,
        fetchPermissionAccess,
        fetchUserPermissionAsync,
        saveUserPermissionAccess,
        saveUserPermissionAccessBatch
    }

})